import * as React from "react";
import { SelectProps } from "antd/lib/select";
import { Select } from "antd";

interface AccessRightsSelectProps extends SelectProps<string> {}

export class AccessRightsSelect extends React.Component<AccessRightsSelectProps> {
  render() {
    return (
      <Select style={{ minWidth: 150 }} {...this.props}>
        <Select.Option key={"READONLY"} value={"READONLY"}>
          {"READ"}
        </Select.Option>
        <Select.Option key={"WRITE"} value={"WRITE"}>
          {"WRITE"}
        </Select.Option>
      </Select>
    );
  }
}
